import { Link } from 'react-router-dom';

const galleryItems = [
  {
    image: 'https://public.readdy.ai/ai/img_res/2fcedc2422227356bd8ca3f764afef92.jpg',
    label: 'Pattern Making',
    seq: 1,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=tailor%20hands%20using%20professional%20fabric%20shears%20cutting%20precisely%20along%20chalk%20line%20through%20double-layered%20fine%20charcoal%20Italian%20wool%20suiting%20on%20large%20wooden%20cutting%20table%20dramatic%20overhead%20editorial%20lighting%20close-up%20sharp%20scissors%20blade%20gleaming%20craftsmanship%20detail%20Massachusetts%20bespoke%20suit%20maker%20premium&width=600&height=800&seq=gal-cut-0316&orientation=portrait',
    label: 'Expert Cutting',
    seq: 2,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=skilled%20tailor%20hands%20using%20needle%20and%20thread%20hand-stitching%20the%20silk%20pick%20stitch%20detail%20along%20the%20lapel%20edge%20of%20a%20fine%20navy%20suit%20jacket%20close-up%20macro%20photography%20thimble%20on%20finger%20warm%20workshop%20light%20buttery%20bokeh%20background%20craftsmanship%20artisan%20detail%20Massachusetts%20bespoke%20clothier%20editorial%20luxury%20fashion&width=600&height=800&seq=gal-stitch-0317&orientation=portrait',
    label: 'Hand Stitching',
    seq: 3,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=final%20fitting%20of%20bespoke%20charcoal%20suit%20jacket%20tailor%20checking%20shoulder%20line%20and%20drape%20on%20smartly%20dressed%20client%20from%20behind%20in%20boutique%20fitting%20room%20mirror%20warm%20flattering%20light%20pin%20in%20hand%20last%20adjustments%20premium%20tailoring%20Massachusetts%20clothier%20editorial%20behind%20the%20scenes%20craftsmanship%20photography&width=600&height=800&seq=gal-fit-0318&orientation=portrait',
    label: 'The Final Fitting',
    seq: 4,
  },
];

const CraftsmanshipGallery = () => {
  return (
    <section className="py-32 bg-[#111111] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-4">
              The Craft
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
              Every Detail,<br />Deliberately Made
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              From the first chalk mark to the final hand stitch, every step of our process
              reflects 55+ years of mastery. This is what separates bespoke from everything else.
            </p>
          </div>
          <div className="lg:text-right">
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 bg-[#C4A962] text-white px-8 py-4 rounded-xl font-semibold hover:bg-[#B39952] transition-all transform hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-calendar-line"></i>
              Book Your Consultation
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {galleryItems.map((item) => (
            <div key={item.seq} className="group relative rounded-2xl overflow-hidden cursor-pointer">
              <div className="h-80 lg:h-96">
                <img
                  src={item.image}
                  alt={item.label}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-white font-semibold text-sm tracking-wide">{item.label}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-white/10 pt-16">
          {[
            { num: '55+', label: 'Years of mastery in bespoke tailoring' },
            { num: '3,500+', label: 'Clients who trust our craftsmanship' },
            { num: '100%', label: 'Custom — every garment made to order' },
            { num: '5,000+', label: 'Premium fabrics from world mills' },
          ].map((stat) => (
            <div key={stat.num} className="text-center">
              <p className="text-4xl font-bold text-[#C4A962] mb-2">{stat.num}</p>
              <p className="text-gray-400 text-sm leading-relaxed">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CraftsmanshipGallery;
